<template>
    <div>
        <annual-leave-report-list></annual-leave-report-list>
    </div>
    </template>
    <script>
    export default {}
    </script>
    